import { useEffect, useState } from 'react';

/**
 * Reads the exact site-property check ws-mycars-nav's own Widget.jsx uses to
 * decide its own visibility, so the header icon and the drawer's CTA button
 * can never disagree with each other -- or with ws-mycars-nav -- about
 * whether My Cars is on for this site.
 *
 * Read on mount (not at initial render) so this client-only global never
 * diverges from the server-rendered markup and trips a hydration mismatch.
 * Returns `null` until that mount-time read resolves -- distinct from
 * `false`, so a caller (MyCarsHeaderIcon) can tell "not yet known" apart
 * from "known disabled" and reserve layout space accordingly.
 *
 * @returns {boolean|null}
 */
const useMyCarsEnabled = () => {
	const [isEnabled, setIsEnabled] = useState(null);

	useEffect(() => {
		const siteProperties = window.DDC?.siteProperties ?? {};
		setIsEnabled(
			siteProperties.enableMyCars === 'true' &&
				siteProperties.disableMyCarsToolbar !== 'true'
		);
	}, []);

	return isEnabled;
};

export default useMyCarsEnabled;
